import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sf-lib-web-layout-templates',
  template: `
    <p>
      lib-web-layout-templates works!
    </p>
  `,
  styles: [
  ]
})
export class LibWebLayoutTemplatesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
